import { render, staticRenderFns } from "./AddNewPatientCard.vue?vue&type=template&id=e6a68840&scoped=true"
import script from "./AddNewPatientCard.vue?vue&type=script&lang=js"
export * from "./AddNewPatientCard.vue?vue&type=script&lang=js"
import style0 from "./AddNewPatientCard.vue?vue&type=style&index=0&id=e6a68840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a68840",
  null
  
)

export default component.exports